// extracted by mini-css-extract-plugin
module.exports = {"details":"TeamListItem_details__eTB1H","title":"TeamListItem_title__7SIIB","description":"TeamListItem_description__3JXOz","role":"TeamListItem_role__1OcNq"};